import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Form, Select,Button, Space, Popconfirm } from 'antd';
import Header from "../../components/Header"
import Footer from '../../components/Footer';
import api from '../../services/api';
import { message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao';
import ModalNovoVinculoOrgaoServico from './ModalNovoVinculoOrgaoServico';

interface VinculoOrgaoServicoProps {
    permissao?: any
    modalStatus?: any,
    setNovoVinculoOrgaoServicoModal?: any,
    setEditarVinculoOrgaoServicoModal?: any
}

const VinculoOrgaoServico: React.FC<VinculoOrgaoServicoProps> = (prop) => {
    let vinculoOrgaoservico: any;
    let vinculoOrgaoservicos: any[] = [];
    const [vinculoOrgaoservicoResponse, setVinculoOrgaoservicoResponse] = useState<any[]>();
    const [loading, setLoading] = useState(false);
    const { Option } = Select;
    let orgaos: any[] = [];
    const [orgaosInput, setOrgaosInput] = useState<any[]>();
    let servicos: any[] = [];
    const [servicosInput, setServicosInput] = useState<any[]>();

    useEffect(() => {
        carregarDropdown();
        Buscar({ vinculoOrgaoServicoID: 0, orgaoID: 0, servicoID: 0 });
    }, [])

    useEffect(() => {
        Buscar({ vinculoOrgaoServicoID: 0, orgaoID: 0, servicoID: 0 });
    }, [prop.modalStatus[0]])

    const carregarDropdown = async () => {
        api.get(`Orgao/getall`).then((response) => {
            orgaos = response.data;
            setOrgaosInput(orgaos)
        })
        api.get(`Servico/getall`).then((response) => {
            servicos = response.data;
            setServicosInput(servicos)
        })
    }

    const novoVinculoOrgaoservico = async (values: any) => {
        prop.setNovoVinculoOrgaoServicoModal(true);
    }
    const editarVinculoOrgaoservico = (values: any) => {
        prop.setEditarVinculoOrgaoServicoModal(true, values)
    }

    const ativarDesativarVinculoOrgaoservico = (vinculoOrgaoServico: any, ehAtivo: boolean) => {
        setLoading(true);
        api.put(`VinculoOrgaoServico`, {
            VinculoOrgaoServicoID: vinculoOrgaoServico.vinculoOrgaoServicoID,
            OrgaoID: vinculoOrgaoServico.orgaoID,
            ServicoID: vinculoOrgaoServico.servicoID,
            Ativo: ehAtivo,
        }
        ).then(response => {
            message.success('Vínculo alterado com sucesso!');
        }).catch(() => {
            message.error('Falha na requisição');
        }).finally(() => {
            Buscar({vinculoOrgaoServicoID: 0, orgaoID: 0, servicoID: 0 });
            setLoading(false);
        })
    }

    const Buscar = async (values: any) => {
        await api.post(`VinculoOrgaoServico/getcomfiltros`, {
            vinculoOrgaoServicoID: 0,
            orgaoID: values.orgao,
            servicoID: values.servico,
            Ativo: values.ativo == null ? null : values.ativo === "true" ? true : false,
        })
            .then((response: any) => {
                if (response.status === 200) {
                    response.data.forEach((e: any) => {
                        vinculoOrgaoservico = {
                            key: e.vinculoOrgaoServicoID,
                            vinculoOrgaoServicoID: e.vinculoOrgaoServicoID,
                            servicoID: e.servicoID,
                            orgaoID: e.orgaoID,
                            orgaoNome: e.orgao.nome,
                            orgao: e.orgao,
                            servico: e.servico,
                            servicoDescricao: e.servico.descricao,
                            ativo: e.ativo,
                        }
                        vinculoOrgaoservicos.push(vinculoOrgaoservico);
                    });
                    setVinculoOrgaoservicoResponse(vinculoOrgaoservicos);
                    setLoading(false);
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')
                setLoading(false);
            });

        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 50);
    };

    const columns: ColumnsType<any> = [
        {
            title: 'Orgão',
            dataIndex: 'orgaoNome',
            width: '30%'
        },
        {
            title: 'Serviço',
            dataIndex: 'servicoDescricao',
            width: '30%'
        },
        {
            title: 'Ativo',
            dataIndex: 'ativo',
            width: '20%',
            render: (text: any, record: any) => (<p>{record.ativo ? 'Sim' : 'Não'}</p>)

        },
        {
            title: 'Ações',
            key: 'action',
            render: (text, record: any) => (

                <Space size="middle">
                    {/* {prop.permissao[0].permissaoAcesso?.editar === true ?
                        <Button htmlType="button" disabled >Editar</Button>
                        : null} */}
                    {
                        record.ativo === true ?
                            prop.permissao[0].permissaoAcesso?.editar === true ?
                                <Popconfirm key={record.vinculoOrgaoServicoID} placement="top" title="Você tem certeza que deseja desativar esse Vínculo?" onConfirm={() => { ativarDesativarVinculoOrgaoservico(record, false); }} okText="Sim" cancelText="Não">
                                    <Button type="primary" key={record.vinculoOrgaoServicoID} danger >  Desativar </Button>
                                </Popconfirm>
                                : null
                            :
                            prop.permissao[0].permissaoAcesso?.editar === true ?
                                <Popconfirm key={record.vinculoOrgaoServicoID} placement="top" title="Você tem certeza que deseja ativar esse Vínculo?" onConfirm={() => { ativarDesativarVinculoOrgaoservico(record, true); }} okText="Sim" cancelText="Não">
                                    <Button type="primary" key={record.vinculoOrgaoServicoID}  >  Ativar </Button>
                                </Popconfirm>
                                : null
                    }

                </Space>
            ),
            fixed: 'right' as 'right',
        }
    ];


    return (
        <div>
            <Header></Header>
            <br />
            <div className="container">
                <fieldset className="fieldset-consulta">
                    <Spin spinning={false}>
                        <Form onFinish={Buscar}
                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                            layout="horizontal"
                            size="middle"
                        >
                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                <Col className="gutter-row" span={8}>
                                    <Form.Item
                                        label="Orgão"
                                        name="orgao"
                                    >
                                        <Select placeholder="Orgão">
                                            {orgaosInput?.map(orgao => (
                                                <Option value={orgao.orgaoID}>{orgao.nome}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={8}>
                                    <Form.Item
                                        label="Serviço"
                                        name="servico"
                                    >
                                        <Select placeholder="Serviço">
                                            {servicosInput?.map(servico => (
                                                <Option value={servico.servicoID}>{servico.descricao}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={8}>
                                    <Form.Item
                                        label="Ativo"
                                        name="ativo"
                                        initialValue="null"
                                    >
                                        <Select placeholder="Ativo">
                                            <Option value="null">Selecione</Option>
                                            <Option value="true">Sim</Option>
                                            <Option value="false">Não</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item className="buttons">
                                {prop.permissao[0].permissaoAcesso?.cadastrar === true ?
                                    <Button className="button-novo" onClick={novoVinculoOrgaoservico} type="ghost" htmlType="button">
                                        Novo Vínculo
                                    </Button>
                                    : null}
                                <Button className="button-filtrar" type="primary" htmlType="submit">
                                    Filtrar
                                </Button>
                            </Form.Item>
                        </Form>
                    </Spin>
                </fieldset>
                <br />
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Table loading={loading} columns={columns} dataSource={vinculoOrgaoservicoResponse} rowKey={"vinculoOrgaoservicoID"} bordered={true}></Table>
                    </Col>
                </Row>
            </div>
            <Footer></Footer>
            <ModalNovoVinculoOrgaoServico></ModalNovoVinculoOrgaoServico>
        </div>
    );
}
const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}

export default connect(mapStateToProps, mapDispatcToProps)(VinculoOrgaoServico);